import CopyLink from './copyLink';
import BreadcrumbModifier from './breadcrumbModifier';
import Searchbar from './searchbar';

export default class MainHeader {
  constructor(app) {
    this.app = app;

    this.init = this.init.bind(this);
    this.destroy = this.destroy.bind(this);

    this.init();
  }

  init() {
    this.copyLink = new CopyLink(this);
    this.breadcrumbModifier = new BreadcrumbModifier(this);
    this.searchbarDesktop = new Searchbar(this, '.js-searchbar-desktop');
    this.searchbarMobile = new Searchbar(this, '.js-searchbar-mobile');
  }

  destroy() {
    if (typeof this.copyLink.destroy !== 'undefined') this.copyLink.destroy();
    if (typeof this.breadcrumbModifier.destroy !== 'undefined') this.breadcrumbModifier.destroy();
    if (typeof this.searchbarDesktop.destroy !== 'undefined') this.searchbarDesktop.destroy();
    if (typeof this.searchbarMobile.destroy !== 'undefined') this.searchbarMobile.destroy();
  }
}



// WEBPACK FOOTER //
// ./scripts/components/mainHeader.js